import React from 'react'
import { getActivityIconComponent, hasActivityIcon } from '../../common/workoutActivities'

interface AppleSFSymbolProps {
  activityValue: string
  className?: string
  style?: React.CSSProperties
  isInactive?: boolean
}

/**
 * Apple SF Symbol component that uses static React component imports
 * This approach is more efficient than fetching SVG content at runtime
 * and prevents webpack from creating thousands of chunk files
 */
export const AppleSFSymbol: React.FC<AppleSFSymbolProps> = ({
  activityValue,
  className,
  style,
  isInactive = false,
}) => {
  // Check if we have a static icon for this activity
  if (!hasActivityIcon(activityValue)) {
    return null
  }

  // Get the React component for this activity
  const IconComponent = getActivityIconComponent(activityValue)
  if (!IconComponent) {
    return null
  }

  // Render the icon component directly
  return (
    <IconComponent
      className={className}
      style={{
        width: '24px',
        height: '24px',
        //opacity: isInactive ? 0.6 : 1,
        ...style,
      }}
    />
  )
}
